<template>
  <div id="app">
    <div class="container">
      <navbar></navbar>
      <router-view></router-view>
    </div>
          <Footer></Footer>

  </div>
</template>

<script>
import Register from "@/components/Register";
import Navbar from "@/components/Navbar";
import Firebase from "firebase";
import Login from "@/components/Login";
import Profile from "@/components/Profile";
import { mapState } from "vuex";
import { mapMutations } from "vuex";
import store from "@/store";
import Footer from "@/components/Footer";
import Kyc from "@/components/Kyc";

export default {
  name: "App",
  components: {
    Navbar: Navbar,
    Login: Login,
    Profile: Profile,
    Footer: Footer,
    Kyc: Kyc
  },

  computed: {
    ...mapState(["storeEmail"])
  },

  beforeCreate() {
    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        //alert('ok');
        // se sono loggato scrivo nello store la mia email
        // la mail è la discriminante // solo uno user per email
        this.$store.commit("SENDUSEREMAIL", user.email);
        this.$store.commit("SENDUSERID", user.uid);
      }
    });
  }
};
</script>



<style>
@import "./assets/styles/custom.css";
</style>



// WEBPACK FOOTER //
// src/App.vue